import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store/store";

export interface Preset {
  presetId: string;
  preset: string;
  configuration: string;
}

interface PresetsState {
  presets: Preset[];
}

const initialState: PresetsState = {
  presets: [],
};

export const presetsSlice = createSlice({
  name: "presets",
  initialState,
  reducers: {
    setPresets: (state, action: PayloadAction<Preset[]>) => {
      state.presets = action.payload;
    },
    deletePreset: (state, action: PayloadAction<string>) => {
      state.presets = state.presets.filter(
        (p) => p.presetId !== action.payload
      );
    },
    addPreset: (state, action: PayloadAction<Preset>) => {
      state.presets = [...state.presets, action.payload];
    },
  },
});

export const { setPresets, deletePreset, addPreset } = presetsSlice.actions;

export default presetsSlice.reducer;
